
{
  "familyId": "GET-WORTEL",
  "questions": [
    {
      "id": "GET-WORTEL-001",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Een leerling beweert: '√9 = 4,5, want je deelt 9 door 2.' Welk antwoord laat zien wat er fout gaat en geeft de juiste betekenis?",
      "context": null,
      "options": [
        "√9 = 3 — de wortel vraagt welk getal × zichzelf 9 geeft, niet welk getal × 2 gelijk is aan 9",
        "√9 = 18 — de wortel betekent vermenigvuldigen met 2",
        "√9 = 4,5 — de leerling heeft gelijk, wortel is delen door 2",
        "√9 = 18 — de wortel is hetzelfde als optellen"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_meaning",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wortel-bewerkingsfout", "label": "Vermenigvuldigen met 2 i.p.v. wortel", "optionIndex": 1 },
          { "id": "get.wortel-halveren", "label": "Delen door 2 i.p.v. wortel", "optionIndex": 2 },
          { "id": "get.wortel-bewerkingsfout", "label": "Optellen i.p.v. wortel", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 3,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat is een wortel?",
            "content": "Het wortelteken √ vraagt: welk getal × zichzelf = het getal onder het teken? Voorbeeld: √9 = 3, want 3 × 3 = 9."
          }
        }
      ],
      "feedback": {
        "explanationText": "De leerling verwart 'wortel' met 'delen door 2'. Maar het wortelteken √ stelt een andere vraag: welk getal vermenigvuldigd met zichzelf geeft dit getal? Bij √9 zoek je: ? × ? = 9. Dat is 3, want 3 × 3 = 9. De wortel is het omgekeerde van het kwadraat: 3² = 9 dus √9 = 3.",
        "solutionSteps": [
          "√ betekent: welk getal × zichzelf = ...?",
          "Zoek: ? × ? = 9",
          "Probeer 3: 3 × 3 = 9 ✓",
          "Dus √9 = 3 — niet 9 ÷ 2 = 4,5"
        ],
        "distractorExplanations": {
          "0": "Goed! De leerling deelde door 2, maar de wortel vraagt: ? × ? = 9. Dat is 3.",
          "1": "Vermenigvuldigen met 2 is geen wortel. √9 ≠ 9 × 2 = 18. De wortel vraagt: welk getal × zichzelf = 9? Dat is 3.",
          "2": "Dit is de denkfout van de leerling. Delen door 2 is geen wortel. √9 = 3 (want 3 × 3 = 9), niet 4,5.",
          "3": "Optellen is geen wortel. √9 ≠ 9 + 9. De wortel vraagt: welk getal × zichzelf = 9? Dat is 3."
        }
      }
    },
    {
      "id": "GET-WORTEL-002",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{16}$ =",
      "context": null,
      "options": ["4", "8", "2", "256"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixteen",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.wortel-halveren", "label": "Wortel als halveren (16 ÷ 2 = 8)", "optionIndex": 1 },
          { "id": "get.wortel-bewerkingsfout", "label": "2 i.p.v. de echte wortel (4)", "optionIndex": 2 },
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat i.p.v. wortel (16 × 16)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 4,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 16? Probeer: 4 × 4 = 16. ✓ Dus √16 = 4."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 16 geeft. Probeer 4: 4 × 4 = 16 ✓. Dus √16 = 4. Tip: leer de kwadraten uit je hoofd: 1, 4, 9, 16, 25, 36, 49, 64, 81, 100.",
        "solutionSteps": [
          "Zoek: ? × ? = 16",
          "Probeer 4: 4 × 4 = 16 ✓",
          "Dus √16 = 4",
          "Controleer met de kwadratentabel: 4² = 16, dus √16 = 4 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √16 = 4, want 4 × 4 = 16.",
          "1": "Je hebt waarschijnlijk 16 ÷ 2 = 8 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 16? Dat is 4 (niet 8, want 8 × 8 = 64).",
          "2": "2 × 2 = 4, niet 16. Probeer 4: 4 × 4 = 16 ✓. Dus √16 = 4.",
          "3": "Je hebt 16 × 16 = 256 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 16? Dat is 4."
        }
      }
    },
    {
      "id": "GET-WORTEL-003",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{25}$ =",
      "context": null,
      "options": ["5", "3", "12,5", "625"],
      "correctAnswer": 0,
      "conceptId": "square_root_twentyfive",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wortel-onder-correct", "label": "Wortel onderschat (3 i.p.v. 5)", "optionIndex": 1 },
          { "id": "get.wortel-halveren", "label": "Wortel als halveren (25 ÷ 2)", "optionIndex": 2 },
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat i.p.v. wortel (25 × 25)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 5,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 25? Probeer: 5 × 5 = 25. ✓ Dus √25 = 5."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 25 geeft. Probeer 5: 5 × 5 = 25 ✓. Dus √25 = 5. Tip: 25 is het kwadraat van 5. Leer de kwadraten uit je hoofd: 1, 4, 9, 16, 25, 36, 49, 64, 81, 100.",
        "solutionSteps": [
          "Zoek: ? × ? = 25",
          "Probeer 5: 5 × 5 = 25 ✓",
          "Dus √25 = 5",
          "Controleer: 5² = 25, dus √25 = 5 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √25 = 5, want 5 × 5 = 25.",
          "1": "3 × 3 = 9, niet 25. Probeer hoger: 5 × 5 = 25 ✓. Dus √25 = 5, niet 3. Onthoud de kwadratentabel.",
          "2": "Je hebt waarschijnlijk 25 ÷ 2 = 12,5 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 25? Dat is 5.",
          "3": "Je hebt 25 × 25 = 625 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 25? Dat is 5."
        }
      }
    },
    {
      "id": "GET-WORTEL-004",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{64}$ =",
      "context": null,
      "options": ["8", "32", "4", "4096"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixtyfour",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.8,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.wortel-halveren", "label": "Wortel als halveren (64 ÷ 2 = 32)", "optionIndex": 1 },
          { "id": "get.wortel-bewerkingsfout", "label": "Verkeerde wortel (4 i.p.v. 8)", "optionIndex": 2 },
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat i.p.v. wortel (64²)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 8,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 64? Probeer: 8 × 8 = 64. ✓ Dus √64 = 8."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 64 geeft. Probeer 8: 8 × 8 = 64 ✓. Dus √64 = 8. Tip: 64 = 2⁶, en √(2⁶) = 2³ = 8. Dit laat zien hoe machten en wortels samenhangen.",
        "solutionSteps": [
          "Zoek: ? × ? = 64",
          "Probeer 8: 8 × 8 = 64 ✓",
          "Dus √64 = 8",
          "Tip: 64 zit in de kwadratentabel: 8² = 64 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √64 = 8, want 8 × 8 = 64.",
          "1": "Je hebt waarschijnlijk 64 ÷ 2 = 32 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 64? Dat is 8 (niet 32, want 32 × 32 = 1024).",
          "2": "4 × 4 = 16, niet 64. Probeer 8: 8 × 8 = 64 ✓. Dus √64 = 8.",
          "3": "Je hebt 64 × 64 = 4096 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 64? Dat is 8."
        }
      }
    },
    {
      "id": "GET-WORTEL-005",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{100}$ =",
      "context": null,
      "options": ["10", "5", "50", "10000"],
      "correctAnswer": 0,
      "conceptId": "square_root_hundred",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.82,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wortel-onder-correct", "label": "Wortel onderschat (5 i.p.v. 10)", "optionIndex": 1 },
          { "id": "get.wortel-halveren", "label": "Wortel als halveren (100 ÷ 2 = 50)", "optionIndex": 2 },
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat i.p.v. wortel (100²)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 10,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 100? Probeer: 10 × 10 = 100. ✓ Dus √100 = 10."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 100 geeft. Probeer 10: 10 × 10 = 100 ✓. Dus √100 = 10. Dit is een makkelijk te onthouden wortel: √100 = 10. Het verband met machten van 10: 10² = 100, dus √100 = 10.",
        "solutionSteps": [
          "Zoek: ? × ? = 100",
          "Probeer 10: 10 × 10 = 100 ✓",
          "Dus √100 = 10",
          "Controleer: 10² = 100, dus √100 = 10 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √100 = 10, want 10 × 10 = 100.",
          "1": "5 × 5 = 25, niet 100. Probeer hoger: 10 × 10 = 100 ✓. Dus √100 = 10, niet 5.",
          "2": "Je hebt waarschijnlijk 100 ÷ 2 = 50 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 100? Dat is 10.",
          "3": "Je hebt 100 × 100 = 10.000 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 100? Dat is 10."
        }
      }
    },
    {
      "id": "GET-WORTEL-006",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Welke is groter: $\\sqrt{36}$ of $\\sqrt{49}$?",
      "context": null,
      "options": [
        "$\\sqrt{49}$",
        "$\\sqrt{36}$",
        "ze zijn even groot",
        "dat kun je niet zeggen"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_compare",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wortel-vergelijken-fout", "label": "Verkeerde richting bij wortels vergelijken", "optionIndex": 1 },
          { "id": "get.wortel-vergelijken-fout", "label": "Beide wortels gelijk aangenomen", "optionIndex": 2 },
          { "id": "get.wortel-vergelijken-fout", "label": "Niet gerekend, gokken", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 6,
            "mode": "root"
          }
        },
        {
          "type": "squareGrid",
          "data": {
            "size": 7,
            "mode": "root"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortels vergelijken",
            "content": "Bereken beide wortels: √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 > √36."
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken beide wortels. √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 is groter. Tip: een groter getal onder het wortelteken geeft altijd een grotere wortel. Dus je kunt ook zonder rekenen zien dat √49 > √36, want 49 > 36.",
        "solutionSteps": [
          "√36 = 6 (want 6 × 6 = 36)",
          "√49 = 7 (want 7 × 7 = 49)",
          "Vergelijk: 7 > 6",
          "Dus √49 > √36 — een groter getal onder √ geeft altijd een grotere wortel"
        ],
        "distractorExplanations": {
          "0": "Goed! √49 = 7 en √36 = 6, dus √49 > √36.",
          "1": "√36 = 6 en √49 = 7. Omdat 7 > 6, is √49 groter dan √36.",
          "2": "Ze zijn niet even groot. √36 = 6 en √49 = 7. Dat zijn verschillende getallen.",
          "3": "Je kunt het wél zeggen. Bereken beide: √36 = 6 en √49 = 7. Vergelijk: 7 > 6, dus √49 is groter."
        }
      }
    },
    {
      "id": "GET-WORTEL-007",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "square_root_builder",
      "question": "Bouw een vierkant om $\\sqrt{25}$ te berekenen.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "squareRootBuilder": {
          "targetValue": 25,
          "maxSize": 10
        }
      },
      "conceptId": "square_root_builder_25",
      "variantIndex": 7,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat en wortel verwisseld" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel bouwen",
            "content": "Een vierkant met oppervlakte 25 heeft zijden van 5, want 5 × 5 = 25. Dus √25 = 5."
          }
        }
      ],
      "feedback": {
        "explanationText": "Om een oppervlakte van 25 te krijgen, moet je een vierkant van 5 bij 5 maken. 5 × 5 = 25. De lengte van de zijde is de wortel: √25 = 5.",
        "solutionSteps": [
          "Doel: oppervlakte 25",
          "Probeer zijde 5: 5 × 5 = 25 ✓",
          "Dus √25 = 5"
        ]
      }
    },
    {
      "id": "GET-WORTEL-008",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "square_root_builder",
      "question": "Bouw een vierkant om $\\sqrt{49}$ te berekenen.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "squareRootBuilder": {
          "targetValue": 49,
          "maxSize": 10
        }
      },
      "conceptId": "square_root_builder_49",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.wortel-kwadraat-verwarring", "label": "Kwadraat en wortel verwisseld" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel bouwen",
            "content": "Een vierkant met oppervlakte 49 heeft zijden van 7, want 7 × 7 = 49. Dus √49 = 7."
          }
        }
      ],
      "feedback": {
        "explanationText": "Om een oppervlakte van 49 te krijgen, moet je een vierkant van 7 bij 7 maken. 7 × 7 = 49. De lengte van de zijde is de wortel: √49 = 7.",
        "solutionSteps": [
          "Doel: oppervlakte 49",
          "Probeer zijde 7: 7 × 7 = 49 ✓",
          "Dus √49 = 7"
        ]
      }
    },
    {
      "id": "GET-WORTEL-009",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "comparison_judge",
      "question": "Drie leerlingen schatten $\\sqrt{50}$. Wie redeneert het scherpst?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "noor", "content": "Noor: √50 ligt tussen 7 en 8, want 7² = 49 en 8² = 64. Het antwoord is iets meer dan 7." },
            { "id": "kees", "content": "Kees: √50 = 25, want je deelt 50 door 2." },
            { "id": "mila", "content": "Mila: √50 = 5, want het getal vóór de 0 is 5." }
          ],
          "criterion": "Wie gebruikt het juiste idee (welk getal × zichzelf zit dichtbij 50)?",
          "correctIndex": 0
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortels schatten",
            "content": "Zoek twee kwadraten waartussen het getal ligt. 50 ligt tussen 49 (=7²) en 64 (=8²). Dus √50 ligt tussen 7 en 8 — dichter bij 7.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_root_estimate_judge",
      "variantIndex": 9,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.wortel-halveren", "label": "Wortel als halveren", "optionIndex": 1 },
          { "id": "get.wortel-eerste-cijfer", "label": "Wortel als eerste cijfer van het getal", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Noor gebruikt het juiste idee: je vergelijkt 50 met de dichtstbijzijnde kwadraten. 7² = 49 en 8² = 64, dus √50 zit tussen 7 en 8 — dichtbij 7. Kees deelt door 2 (dat is geen wortel). Mila kijkt naar het eerste cijfer (dat heeft niets met de wortel te maken). Voor exacte berekening heb je een rekenmachine nodig (√50 ≈ 7,07), maar Noor's schatting is wiskundig correct.",
        "solutionSteps": [
          "Welke kwadraten liggen rond 50? 7² = 49 en 8² = 64",
          "50 ligt tussen 49 en 64, dus √50 ligt tussen 7 en 8",
          "50 is heel dicht bij 49, dus √50 ligt heel dicht bij 7",
          "Noor's redenering klopt"
        ]
      }
    }
  ]
}
